"use client";

import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import Home from "./components/sections/Home";
import Management from "./components/sections/Management";
import Marketplace from "./components/sections/Marketplace";
import Pricing from "./components/sections/Pricing";
import About from "./components/sections/About";
import Footer from "./components/Footer";
import Downloads from "./components/sections/Downloads";
import Fintech, { FintechBand } from "./components/sections/Fintech";

/**
 * Routing side effects: land at the top of a new page, and honour /#section
 * links coming from other routes.
 */
const RouteEffects = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const target = document.getElementById(id);
      if (target) {
        requestAnimationFrame(() =>
          target.scrollIntoView({ behavior: "smooth", block: "start" })
        );
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

const HomePage = () => (
  <>
    <Home />
    <Management />
    <Marketplace />
    <FintechBand />
    <Pricing />
    <About />
  </>
);

const AppContent = () => {
  const { t } = useLanguage();

  return (
    <>
      <a className="skip-link" href="#main">
        {t.ui.skip}
      </a>
      <Navbar />
      <RouteEffects />
      <main id="main" className="pt-[68px]">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/fintech" element={<Fintech />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
